import xss from 'xss'

const CELL_ATTRIBUTES = ['class', 'colspan', 'rowspan', 'align', 'valign', 'width']
const TEXT_ATTRIBUTES = ['class']
const STYLED_TEXT_ATTRIBUTES = [...TEXT_ATTRIBUTES, 'style']

// 表エディタ（libs/client/table-editor）が出力する表と、セル内の書式・リンクだけを許可する
// - 表のHTMLは顧客側（/api/ext/gen-ai/log 等）や、会話カードを編集できる一般ユーザーからも保存できるため、タグ・属性は許可リストにないものを除く
// - img などの外部リソースを読み込むタグは、表エディタが出力しないため許可しない
// - font・書式タグの style は、本番の会話カードの表の回答で使われているもの（2026-10 時点）に合わせて残す
const TABLE_WHITE_LIST: Record<string, string[]> = {
  table: ['class', 'width', 'border', 'align'],
  caption: TEXT_ATTRIBUTES,
  colgroup: ['span', 'width'],
  col: ['span', 'width'],
  thead: TEXT_ATTRIBUTES,
  tbody: TEXT_ATTRIBUTES,
  tfoot: TEXT_ATTRIBUTES,
  tr: ['class', 'align', 'valign'],
  th: CELL_ATTRIBUTES,
  td: CELL_ATTRIBUTES,
  a: ['href', 'target', 'rel', 'title'],
  div: STYLED_TEXT_ATTRIBUTES,
  span: STYLED_TEXT_ATTRIBUTES,
  font: ['class', 'color', 'style'],
  p: TEXT_ATTRIBUTES,
  br: [],
  b: ['style'],
  strong: ['style'],
  i: [],
  em: ['style'],
  u: [],
  s: [],
  small: [],
  sub: [],
  sup: [],
  ul: [],
  ol: [],
  li: [],
}

// style に残すのは文字の見た目だけ（background-image の url() 等で外部リソースを読み込ませない）
// - color・background-color: 会話カードの校正画面（ProofreaderTable）の差分の強調
// - font-weight・font-family・vertical-align: 会話カードの表の回答で使われているもの
const TABLE_CSS_WHITE_LIST: Record<string, boolean> = {
  color: true,
  'background-color': true,
  'font-weight': true,
  'font-family': true,
  'vertical-align': true,
}

// 許可しないタグはタグだけ除く。ただし `<電話の場合>`・`<260000>` のように英字で始まらないものは、
// ブラウザがタグとして扱わず文字のまま表示するので、文字として残す（エスケープする）
function stripIgnoreTagOnlyHtmlTags(tag: string): string | undefined {
  return /^[a-z]/.test(tag) ? '' : undefined
}

/**
 * 表のHTML（有人対応画面の表のログ、FAQの表の回答）を、描画してもスクリプトが動かないように無害化する。
 * イベント属性（onerror 等）・許可しない style・javascript: のリンクは除き、許可しないタグは中身ごと捨てずにタグだけ除く。
 */
export function sanitizeTableHtml(html: string): string {
  return xss(html, {
    whiteList: TABLE_WHITE_LIST,
    css: { whiteList: TABLE_CSS_WHITE_LIST },
    onIgnoreTag: stripIgnoreTagOnlyHtmlTags,
    stripIgnoreTagBody: ['script', 'style', 'iframe', 'object', 'embed', 'svg', 'math', 'template'],
  })
}
